import { initI18n } from '@argo/common/i18n'

// The insurance application's own words; the shared ones (sign-in,
// registration, the PIN, the nouns every screen needs) are in
// @argo/common/i18n.
//
// The Mongolian is the one customers read, so it is the industry's own
// vocabulary rather than a translation of the English: хураамж тооцох (never
// "үнэ гаргах"), нөхөн төлбөр олгох, нэхэмжлэл гаргах, даатгалын дүн,
// хариуцлагын хязгаар. Where a word is a term of art for the insurer's own
// staff — андеррайтинг, IBNR — it is kept, because those readers use it.
export { setLanguage } from '@argo/common/i18n'

const mn = {
  app: 'Argo Даатгал', brandLine: 'Даатгал',

  // navigation — short enough to read at a glance in the top bar
  cover: 'Даатгал', claims: 'Нэхэмжлэл', queue: 'Нэхэмжлэл', products: 'Бүтээгдэхүүн', report: 'Тайлан',
  shortClaims: 'Нэхэмжлэл', shortQueue: 'Нэхэмжлэл', shortProducts: 'Бүтээгдэхүүн',

  // cover
  myCover: 'Миний даатгал', buyCover: 'Даатгал авах', noCover: 'Танд идэвхтэй даатгал байхгүй байна',
  sumInsured: 'Даатгалын дүн', coverLeft: 'Үлдэгдэл хамгаалалт', premiumWord: 'Хураамж',
  term: 'Хугацаа', days: '{{count}} хоног', starts: 'Эхэлсэн', ends: 'Дуусах',
  policyId: 'Гэрээний дугаар', product: 'Бүтээгдэхүүн',
  chooseProduct: 'Бүтээгдэхүүн сонгох', coverAmount: 'Даатгалын дүн',
  noProducts: 'Одоогоор зарагдаж буй бүтээгдэхүүн байхгүй байна',
  youPay: 'Төлөх хураамж', rateLine: 'Хураамж {{rate}}%',
  buy: 'Даатгуулах', placeBond: 'Барьцаа байршуулах', cancelCover: 'Цуцлах',
  cancelled: 'Цуцлагдсан', refunded: 'Буцаасан хураамж',
  active: 'Идэвхтэй', expired: 'Дууссан',
  cancelConfirm: 'Энэ даатгалыг цуцлах уу?',
  cancelProRata: 'Үлдсэн хугацааны хураамжийг буцаан олгоно.',
  cancelNoRefund: 'Энэ бүтээгдэхүүнийг цуцлахад хураамж буцаахгүй.',
  cancelClaimed: 'Нөхөн төлбөр нэхэмжилсэн даатгалыг цуцлах боломжгүй.',

  // claims
  myClaims: 'Миний нэхэмжлэл', makeClaim: 'Нэхэмжлэл гаргах', noClaims: 'Нэхэмжлэл байхгүй',
  claimAmount: 'Нэхэмжилж буй дүн', dateOfLoss: 'Эрсдэл учирсан огноо',
  evidence: 'Нотлох баримт', chooseFile: 'Файл сонгох', fileTypes: 'PDF, JPEG эсвэл PNG, 10 МБ хүртэл',
  claimed: 'Нэхэмжилсэн', paidWord: 'Олгосон', outstanding: 'Үлдэгдэл',
  reportedOn: 'Мэдэгдсэн', incurredOn: 'Эрсдэл учирсан', closedOn: 'Хаасан',
  open: 'Хянагдаж байна', settled: 'Шийдвэрлэсэн', rejected: 'Татгалзсан',
  payments: 'Олголт', decisions: 'Шийдвэр', downloadEvidence: 'Нотлох баримт татах',
  claimFiled: 'Нэхэмжлэл бүртгэгдлээ', noPolicyToClaim: 'Нэхэмжлэл гаргах идэвхтэй даатгал байхгүй',

  // the insurer's desks
  openClaims: 'Шийдвэрлэх нэхэмжлэл', noOpenClaims: 'Шийдвэрлэх нэхэмжлэл байхгүй',
  holder: 'Даатгуулагч', pay: 'Олгох', settle: 'Хаах', reject: 'Татгалзах',
  amountToPay: 'Олгох дүн', reason: 'Үндэслэл', reasonRequired: 'Татгалзах үндэслэлээ бичнэ үү',
  settleNote: 'Олгоогүй үлдсэн дүн хаагдаж, хамгаалалтад буцна.',
  defineProduct: 'Бүтээгдэхүүн үүсгэх', code: 'Код', name: 'Нэр', description: 'Тайлбар',
  insurerAccount: 'Даатгагчийн данс', coverageLimit: 'Даатгалын дээд дүн', termDays: 'Хугацаа (хоног)',
  rateBps: 'Хураамжийн хувь (bps · 100 = 1%)', refundMode: 'Цуцлалт', refundProRata: 'Хугацаагаар буцаана',
  refundNone: 'Буцаахгүй', onSale: 'Борлуулалтад', saved: 'Хадгаллаа',
  showRetired: 'Бүгдийг харах ({{count}} хаагдсан)', onSaleOnly: 'Зөвхөн борлуулалтад',
  productHint: 'Хураамж = даатгалын дүн × хувь. Даатгалын дээд дүн, хугацаа, цуцлалтын нөхцөлийг блокчэйн хадгална.',

  // the report
  underwriting: 'Андеррайтингийн тайлан', asOf: 'Тайлант огноо', insurerFilter: 'Даатгагч', allInsurers: 'Бүгд',
  premiumBlock: 'Хураамж', claimsBlock: 'Нөхөн төлбөр', resultBlock: 'Үр дүн',
  writtenPremium: 'Бичигдсэн хураамж', earnedPremium: 'Орлогод тооцсон хураамж',
  unearnedPremium: 'Хугацаа хуваарилагдаагүй хураамжийн нөөц',
  paidClaims: 'Олгосон нөхөн төлбөр', outstandingClaims: 'Мэдэгдсэн ч олгоогүй нөөц',
  ibnr: 'Учирсан ч мэдэгдээгүй нөөц (IBNR)', totalClaims: 'Нийт нөхөн төлбөр',
  operatingExpenses: 'Үйл ажиллагааны зардал', margin: 'Андеррайтингийн ашиг (алдагдал)',
  ledgerCash: 'Блокчэйн дэх мөнгөн хөрөнгө', triangle: 'Хөгжлийн гурвалжин',
  policyAge: 'Гэрээний нас (хоног)', developmentDays: 'Хөгжлийн хоног', factor: 'Коэффициент',
  reportedTo: 'Мэдэгдсэн дүн', ultimate: 'Эцсийн дүн', policiesCount: 'Гэрээ', claimsCount: 'Нэхэмжлэл',
  ibnrNote: 'IBNR-ийг сүүлийн хөгжлийн үе хүртэл сунгаж (chain ladder) тооцов.',

  // the issuer's desk: putting settlement money on the ledger
  fundAccount: 'Данс цэнэглэх', mint: 'Гаргах', minted: 'Гарлаа',
  fundHint: 'STABLE бол энэ дэвтрийн төлбөрийн хэрэгсэл. Банкны шилжүүлэг баталгаажсаны дараа л гаргана.',

  // notices the product and the ledger require
  coverNotice: 'Хураамж нэг удаа төлөгдөж, блокчэйнд бичигдэнэ. Хамгаалалт гүйлгээ баталгаажсан үеэс эхэлнэ.',

  // Compulsory cover: the words for what another system decided. The yes/no
  // pair is here because the form offers them as choices for a fact.
  yes: 'Тийм', no: 'Үгүй',
  registered: 'Бүртгэгдсэн', pendingWord: 'Бүртгэл дуусаагүй',
  fixedCover: 'Хариуцлагын хязгаар',
  fixedCoverHint: 'Албан журмын даатгалын хариуцлагын хязгаарыг журмаар тогтоодог тул сонгох шаардлагагүй.',
  externalContract: 'Албан журмын гэрээ',
  externalSource: 'Бүртгэсэн систем', externalNumber: 'Гэрээний дугаар',
  externalHolder: 'Даатгуулагчийн нэр', externalVehicle: 'Тээврийн хэрэгсэл',
  externalDrivers: 'Нэрлэсэн жолооч', externalPdf: 'Гэрээг татах',
  externalPremium: 'Тооцсон хураамж',
  externalPending: 'Хураамж төлөгдсөн ч гэрээ холбооны системд бүртгэгдээгүй байна. Ажилтан гүйцээнэ.',
  externalNotice: 'Хураамжийг Албан журмын даатгагчдын холбооны систем тооцож, гэрээг тэндээ бүртгэнэ.',
  coverNoticeRefund: 'Цуцлахад үлдсэн хугацааны хураамж буцна. Нөхөн төлбөр нэхэмжилсэн бол цуцлах боломжгүй.',
  coverNoticeNoRefund: 'Энэ бүтээгдэхүүнийг цуцлахад хураамж буцаахгүй. Нөхөн төлбөр нэхэмжилсэн бол цуцлах боломжгүй.',
  claimNotice: 'Нэхэмжлэл гаргасан нь нөхөн төлбөр олгоно гэсэн үг биш. Даатгагч судалж шийдвэрлэнэ.',
  claimNoticeEvidence: 'Хавсаргасан баримтын хурууны хээ (SHA-256) блокчэйнд бичигдэж, дараа нь өөрчлөгдөхгүй.',
  // Phase 1: [Нүүр] [Бүтээгдэхүүн] [Профайл]
  tabBalance: 'Нүүр', catalog: 'Бүтээгдэхүүн', profile: 'Профайл',
  productsDesk: 'Удирдлага', shortDesk: 'Удирдлага',
  heldAsBond: 'Барьцаанд', owedOnClaims: 'Нөхөн төлбөрт авах', testFigure: 'туршилт',
  bondsForMe: 'Надад байршуулсан барьцаа', renter: 'Түрээслэгч', landlord: 'Түрээслүүлэгч',
  inEscrow: 'Барьцаанд', releaseOn: 'Буцаагдах өдөр', releasedWord: 'Буцаагдсан дүн', released: 'Буцаасан',
  referralIncome: 'Зуучлалын орлого', referredSales: '{{count}} борлуулалт', allClaims: 'Бүх нэхэмжлэл',
  bondWord: 'Барьцаа', coverWord: 'Даатгал', details: 'Дэлгэрэнгүй',
  getPrice: 'Хураамж тооцох', pricing: 'Тооцож байна…', buying: 'Баталгаажуулж байна…',
  bondAmount: 'Барьцааны дүн', landlordUsername: 'Түрээслүүлэгчийн нэвтрэх нэр',
  referralCode: 'Зуучлагчийн код', optional: 'заавал биш', referredBy: 'Зуучлагч',
  vehicle: 'Тээврийн хэрэгсэл', addVehicle: 'Машин нэмэх', chooseVehicle: 'Машин сонгох',
  licenceYear: 'Жолооны үнэмлэх авсан он', needsTitle: 'Хураамж тооцохын тулд дараахыг бөглөнө үү',
  priceUsed: 'Хураамжийг тооцсон мэдээлэл', howPriced: 'Хураамж хэрхэн тооцогдсон', baseAmount: 'Суурь хураамж',
  confirmFacts: 'Дээрх мэдээлэл үнэн зөв гэдгийг баталж байна',
  falseInfo: 'Мэдээлэл үнэн зөв биш бол нөхөн төлбөрөөс хасах, олгохоос татгалзах үндэслэл болно.',
  quoteExpires: 'Энэ тооцоо {{time}} хүртэл хүчинтэй', editDetails: 'Мэдээлэл засах', fee: 'Үйлчилгээний хураамж',
  bondNotice: 'Барьцаа таны мөнгө хэвээр: түрээс дууссанаас хойш {{days}} хоногт түрээслүүлэгч нэхэмжлэл гаргаагүй бол буцаан олгоно.',
  youPayTotal: 'Нийт төлөх',
  age: 'Нас', sex: 'Хүйс', male: 'Эрэгтэй', female: 'Эмэгтэй', birthDate: 'Төрсөн огноо',
  fromRegNo: 'Нас, хүйсийг регистрийн дугаараас тодорхойлсон.',
  // What a member of staff may do here, in the words the desk uses.
  roleUnderwriter: 'Андеррайтер', roleClaims: 'Нөхөн төлбөр', roleActuary: 'Актуар',
  roleIssuer: 'Мөнгө гаргагч', roleOperator: 'Оператор',
  unknownRegNo: 'Регистрийн дугаараас уншиж чадсангүй — ажилтанд хандана уу',
  plate: 'Улсын дугаар', vehicleClass: 'Ангилал', makeModel: 'Марк, загвар', yearMade: 'Үйлдвэрлэсэн он',
  engineCc: 'Хөдөлгүүр (cc)', vehicleValue: 'Машины үнэлгээ',
  pricingDetails: 'Хураамжид нөлөөлөх мэдээлэл',
  pricingDetailsHint: 'Зөвхөн хураамжид нөлөөлөх мэдээллийг асууна. Өөрчлөгдвөл эндээс шинэчилнэ үү.',
  remove: 'Хасах', edit: 'Засах', noVehicles: 'Бүртгэсэн машин байхгүй',
  myCodes: 'Миний зуучлалын код', earned: 'Олсон шимтгэл',
  policyDetail: 'Гэрээ', moveInEvidence: 'Нүүж орох үеийн байдал', attachFile: 'Файл хавсаргах', noteWord: 'Тэмдэглэл',
  endLease: 'Түрээс дууссаныг бүртгэх',
  endLeaseConfirm: 'Хамгаалалт өнөөдөр дуусч, түрээслүүлэгчийн нэхэмжлэх хугацаа өнөөдрөөс эхэлнэ.',
  escrowAccount: 'Эскроу данс', bondsDesk: 'Идэвхтэй барьцаа', noBonds: 'Идэвхтэй барьцаа байхгүй',
  kindLabel: 'Төрөл', kindCover: 'Даатгал', kindBond: 'Барьцаа', releaseDays: 'Нэхэмжлэх хугацаа (хоног)',
  commissionCap: 'Шимтгэлийн дээд хувь (bps)', referralDefault: 'Зуучлалын анхдагч хувь (bps)',
  tariff: 'Тариф', method: 'Арга', paramsJson: 'Параметр (JSON)', saveTariff: 'Тариф хадгалах',
  referralCodes: 'Зуучлалын код', newCode: 'Шинэ код', referrerAccount: 'Шимтгэл авах данс', labelWord: 'Шошго',
  rateFor: 'Хувь', disable: 'Идэвхгүй болгох', disabledWord: 'Идэвхгүй', setRate: 'Хувь тогтоох',
  // the PIN panel — these lived only in the exchange's own strings
  pinSet: 'Тохируулсан', pinNotSet: 'Тохируулаагүй', currentPin: 'Одоогийн ПИН', newPin: 'Шинэ ПИН',
  pinHint: '4-8 оронтой тоо. Мөнгөн гүйлгээ бүрт шаардана.',
}

const en: typeof mn = {
  app: 'Argo Insurance', brandLine: 'Insurance',

  cover: 'Cover', claims: 'Claims', queue: 'Claims', products: 'Products', report: 'Report',
  shortClaims: 'Claims', shortQueue: 'Claims', shortProducts: 'Products',

  myCover: 'My cover', buyCover: 'Buy cover', noCover: 'You have no cover yet',
  sumInsured: 'Sum insured', coverLeft: 'Cover left', premiumWord: 'Premium',
  term: 'Term', days: '{{count}} days', starts: 'Started', ends: 'Ends',
  policyId: 'Policy', product: 'Product',
  chooseProduct: 'Choose a product', coverAmount: 'Sum insured',
  noProducts: 'Nothing is on sale just now',
  youPay: 'You pay', rateLine: 'Premium {{rate}}%',
  buy: 'Take out cover', placeBond: 'Place the bond', cancelCover: 'Cancel',
  cancelled: 'Cancelled', refunded: 'Refunded',
  active: 'Active', expired: 'Expired',
  cancelConfirm: 'Cancel this cover?',
  cancelProRata: 'The premium for the unexpired term comes back.',
  cancelNoRefund: 'This product refunds nothing on cancellation.',
  cancelClaimed: 'Cover that has been claimed on cannot be cancelled.',

  myClaims: 'My claims', makeClaim: 'Make a claim', noClaims: 'No claims',
  claimAmount: 'Amount claimed', dateOfLoss: 'Date of loss',
  evidence: 'Evidence', chooseFile: 'Choose a file', fileTypes: 'PDF, JPEG or PNG, up to 10 MB',
  claimed: 'Claimed', paidWord: 'Paid', outstanding: 'Outstanding',
  reportedOn: 'Reported', incurredOn: 'Loss', closedOn: 'Closed',
  open: 'Under review', settled: 'Settled', rejected: 'Rejected',
  payments: 'Payments', decisions: 'Decisions', downloadEvidence: 'Download evidence',
  claimFiled: 'Claim filed', noPolicyToClaim: 'No active cover to claim against',

  openClaims: 'Claims to decide', noOpenClaims: 'Nothing waiting',
  holder: 'Policyholder', pay: 'Pay', settle: 'Settle', reject: 'Reject',
  amountToPay: 'Amount to pay', reason: 'Reason', reasonRequired: 'A rejection needs a reason',
  settleNote: 'Anything unpaid is written off and returns to the cover.',
  defineProduct: 'Define a product', code: 'Code', name: 'Name', description: 'Description',
  insurerAccount: 'Insurer account', coverageLimit: 'Maximum cover', termDays: 'Term (days)',
  rateBps: 'Rate (bps · 100 = 1%)', refundMode: 'Cancellation', refundProRata: 'Pro rata refund',
  refundNone: 'No refund', onSale: 'On sale', saved: 'Saved',
  showRetired: 'Show retired ({{count}})', onSaleOnly: 'On sale only',
  productHint: 'Premium = sum insured × rate. The chain holds the maximum cover, the term and the refund rule.',

  underwriting: 'Underwriting report', asOf: 'As at', insurerFilter: 'Insurer', allInsurers: 'All',
  premiumBlock: 'Premium', claimsBlock: 'Claims', resultBlock: 'Result',
  writtenPremium: 'Written premium', earnedPremium: 'Earned premium',
  unearnedPremium: 'Unearned premium reserve',
  paidClaims: 'Paid claims', outstandingClaims: 'Reported but unpaid reserve',
  ibnr: 'Incurred but not reported (IBNR)', totalClaims: 'Total claims',
  operatingExpenses: 'Operating expenses', margin: 'Underwriting result',
  ledgerCash: 'Held on the ledger', triangle: 'Development triangle',
  policyAge: 'Policy age (days)', developmentDays: 'Development days', factor: 'Factor',
  reportedTo: 'Reported', ultimate: 'Ultimate', policiesCount: 'Policies', claimsCount: 'Claims',
  ibnrNote: 'IBNR is the chain-ladder ultimate less what has been reported.',

  fundAccount: 'Fund an account', mint: 'Issue', minted: 'Issued',
  fundHint: 'STABLE is this ledger\'s settlement money. Issue it only against a bank transfer that has cleared.',

  coverNotice: 'The premium is paid once and written to the ledger. Cover starts when the transaction commits.',

  yes: 'Yes', no: 'No',
  registered: 'Registered', pendingWord: 'Not finished',
  fixedCover: 'Limit of liability',
  fixedCoverHint: 'A compulsory policy covers what the regulation says it covers, so there is nothing to choose.',
  externalContract: 'Compulsory contract',
  externalSource: 'Registered in', externalNumber: 'Contract number',
  externalHolder: 'Name on the contract', externalVehicle: 'Vehicle',
  externalDrivers: 'Named drivers', externalPdf: 'Download the contract',
  externalPremium: 'Premium charged',
  externalPending: 'The premium was taken but the contract is not registered in the association\'s system. A member of staff finishes it.',
  externalNotice: "The premium is computed by the insurers' association system, and the contract is registered there.",
  coverNoticeRefund: 'Cancelling returns the premium for the unexpired term. Cover that has been claimed on cannot be cancelled.',
  coverNoticeNoRefund: 'This product returns nothing on cancellation. Cover that has been claimed on cannot be cancelled.',
  claimNotice: 'Filing a claim is not a promise to pay. The insurer decides it.',
  claimNoticeEvidence: 'The fingerprint (SHA-256) of the file you attach is written to the ledger and cannot change afterwards.',
  tabBalance: 'Home', catalog: 'Products', profile: 'Profile',
  productsDesk: 'Desk', shortDesk: 'Desk',
  heldAsBond: 'Held as bond', owedOnClaims: 'Owed on claims', testFigure: 'test',
  bondsForMe: 'Bonds placed with me', renter: 'Renter', landlord: 'Landlord',
  inEscrow: 'Held', releaseOn: 'Returned on', releasedWord: 'Returned', released: 'Released',
  referralIncome: 'Referral income', referredSales: '{{count}} sales', allClaims: 'All claims',
  bondWord: 'Bond', coverWord: 'Cover', details: 'Details',
  getPrice: 'Work out the premium', pricing: 'Working it out…', buying: 'Confirming…',
  bondAmount: 'Bond amount', landlordUsername: "Landlord's username",
  referralCode: 'Referral code', optional: 'optional', referredBy: 'Referred by',
  vehicle: 'Vehicle', addVehicle: 'Add a vehicle', chooseVehicle: 'Choose a vehicle',
  licenceYear: 'Year you began driving', needsTitle: 'To work out the premium we need',
  priceUsed: 'What the premium was based on', howPriced: 'How the premium was reached', baseAmount: 'Base premium',
  confirmFacts: 'I confirm these details are true',
  falseInfo: 'If the details are not true, a claim may be reduced or refused.',
  quoteExpires: 'This quote holds until {{time}}', editDetails: 'Edit details', fee: 'Fee',
  bondNotice: 'The bond stays your money: it comes back {{days}} days after the lease ends unless the landlord has claimed.',
  youPayTotal: 'You pay in total',
  age: 'Age', sex: 'Sex', male: 'Male', female: 'Female', birthDate: 'Born',
  fromRegNo: 'Age and sex are read from your registration number.',
  roleUnderwriter: 'Underwriter', roleClaims: 'Claims', roleActuary: 'Actuary',
  roleIssuer: 'Issuer', roleOperator: 'Operator',
  unknownRegNo: 'Could not be read from your registration number — contact us',
  plate: 'Plate', vehicleClass: 'Class', makeModel: 'Make and model', yearMade: 'Year made',
  engineCc: 'Engine (cc)', vehicleValue: 'Value',
  pricingDetails: 'What the premium depends on',
  pricingDetailsHint: 'Only what changes a premium is asked for. Correct it here whenever it changes.',
  remove: 'Remove', edit: 'Edit', noVehicles: 'No vehicles yet',
  myCodes: 'My referral codes', earned: 'Commission earned',
  policyDetail: 'Policy', moveInEvidence: 'Condition at move-in', attachFile: 'Attach a file', noteWord: 'Note',
  endLease: 'Record the lease ending',
  endLeaseConfirm: "Cover ends today and the landlord's window to claim starts today.",
  escrowAccount: 'Escrow', bondsDesk: 'Bonds in force', noBonds: 'No bonds in force',
  kindLabel: 'Kind', kindCover: 'Cover', kindBond: 'Bond', releaseDays: 'Claim window (days)',
  commissionCap: 'Commission cap (bps)', referralDefault: 'Default referral rate (bps)',
  tariff: 'Tariff', method: 'Method', paramsJson: 'Parameters (JSON)', saveTariff: 'Save tariff',
  referralCodes: 'Referral codes', newCode: 'New code', referrerAccount: 'Paid to account', labelWord: 'Label',
  rateFor: 'Rate', disable: 'Disable', disabledWord: 'Disabled', setRate: 'Set rate',
  pinSet: 'Set', pinNotSet: 'Not set', currentPin: 'Current PIN', newPin: 'New PIN',
  pinHint: '4 to 8 digits. Required for every money movement.',
}

export default initI18n({ mn, en })
